// layouts/auth/ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "layouts/auth/AuthContext";
import { canAccess, isPermsBypassOn } from "./permissions";

export default function ProtectedRoute({ module, action = "read", children }) {
  const { user, isAuth } = useAuth();
  const location = useLocation();

  // Si no hay sesión → ve al login
  if (!isAuth) {
    return (
      <Navigate
        to="/authentication/sign-in"
        state={{ from: location }}
        replace
      />
    );
  }

  const perms = user?.permissions || {};

  // 👇 Detección robusta de admin (mismo criterio que en App.js)
  const isAdmin = !!(
    user?.is_admin ||           // boolean / 1 / true
    user?.isAdmin ||            // camelCase
    user?.admin ||              // otra variante
    user?.role === "admin" ||   // por rol de texto
    user?.permissions?.admin    // flag dentro de permissions
  );

  // ⛔ Bypass de permisos:
  // - Admin → siempre puede ver
  // - ó modo DEV_PERMS_ALLOW_ALL
  if (isAdmin || isPermsBypassOn()) {
    return children;
  }

  // Si la ruta declaró módulo/acción, validamos contra permisos
  if (module) {
    const allowed = canAccess(perms, module, action, /* isAdmin */ false);
    if (!allowed) {
      return (
        <Navigate
          to="/dashboard"
          state={{ from: location, denied: true }}
          replace
        />
      );
    }
  }

  // Sin módulo (ruta pública dentro de sesión) o con permiso → pasa
  return children;
}
